<template>
  <div>
    <!--  Tooltip button -->
    <tippy arrow theme="light-border" trigger="click" animateFill="false" interactive>
      <template v-slot:trigger>
        <div class="c-calendar__add-comment">
          <button
            :title="$t('form.comments.comment')"
            class="button button--action button--action--edit button--small"
          >{{ $t('form.comments.comment') }}</button>
        </div>
      </template>
      <!--  Tooltip Content -->
      <section class="c-calendar__tooltip">
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <p class="u-no-margin">
              <strong>{{ $t('form.comments.comment') }}</strong>
            </p>
          </div>
          <div class="cell small-10">
            <input
              name="comment"
              v-model="editText"
              type="text"
              class="c-calendar__tooltip-comment"
            />
          </div>
          <div class="cell small-2">
            <button
              class="c-calendar__tooltip-save-button button button--action button--action--save"
              @click.prevent="saveWeekDay"
            ></button>
          </div>
        </div>
      </section>
    </tippy>
  </div>
</template>

<script>
export default {
  name: "WeekDayCommentOnly",
  props: {
    comment: {
      type: String,
      default: ""
    }
  },

  data: function() {
    return {
      editedtext: ""
    };
  },
  computed: {
    editText: {
      get: function() {
        return this.comment;
      },

      set: function(newValue) {
        this.editedtext = newValue;
      }
    }
  },
  methods: {
    saveWeekDay: function() {
      this.$emit("saveWeekDay", this.editedtext);
    }
  }
};
</script>